import React from 'react';

import { Typography } from 'components/shared/Typography';

import styles from './MarkerListBlock.module.scss';

const MarkerListBlock = ({
  className,
  data,
}: {
  className: any;
  data: any;
}) => (
  <div className={className}>
    {data.map((item: any) => (
      <div className={styles.item} key={item}>
        <div className={styles.itemOrder} />
        <Typography className={styles.itemText} variant="body1">
          {item}
        </Typography>
      </div>
    ))}
  </div>
);

export default React.memo(MarkerListBlock) as any;
